import { FC, useMemo } from 'react';
import { InvoiceFileProcessingStatusDto } from 'src/generated/services/TFinancialApi';

interface CustomTooltipProps {
  show: boolean;
  data: InvoiceFileProcessingStatusDto;
  mouseX?: number;
  mouseY?: number;
}

export const CustomTooltip: FC<CustomTooltipProps> = ({ show, data, mouseX = 0, mouseY = 0 }) => {
  // Memoized button label based on data
  const label = useMemo(() => {
    // Check if we should show "See Invoice" link
    if (data?.invoiceId && data?.shipmentCount !== data?.processingShipmentCount) {
      return data?.status === 'DUPLICATE' ? 'See Existing Invoice' : 'See Invoice';
    }

    // Show "See File" for other cases
    if (data?.status !== 'BEING_UPLOADED') {
      return 'See File';
    }

    // Disabled state
    return 'See File';
  }, [data?.invoiceId, data?.shipmentCount, data?.processingShipmentCount, data?.status]);

  if (!show) return null;

  return (
    <div
      className='fixed z-[9999] pointer-events-none'
      style={{
        left: `${mouseX}px`,
        top: `${mouseY - 40}px`, // Position above cursor
        transform: 'translateX(-50%)', // Center horizontally on cursor
      }}
    >
      <div className='relative bg-[#202020] text-white px-12 py-8 rounded-8 shadow-lg whitespace-nowrap text-14 font-medium'>
        {/* Arrow pointing down (towards cursor) */}
        <div
          className='absolute left-1/2 -translate-x-1/2 -bottom-[6px]'
          style={{
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: '6px solid #202020',
          }}
        />
        {label}
      </div>
    </div>
  );
};
